import { THEMES } from "./themes";

export interface CssVariableDetails {
  name: string;
  title: string;
  variable: string;
}

export interface CssVariableCategory {
  [key: string]: {
    title: string;
    variables: CssVariableDetails[];
  };
}

export interface CssVariableMap {
  [key: string]: CssVariableCategory;
}

export interface TextVariableMap {
  [key: string]: {
    title: string;
    variables: {
      title: string;
      name: string;
      variable: string;
    }[];
  };
}

export interface CssVariables {
  [key: string]: Record<string, string>;
}

export interface SiteTheme {
  cssVariables: CssVariables;
  customColors?: Record<string, string>;
  value: string;
}

export const SITE_THEMES: Record<string, SiteTheme> = THEMES;
